// series.tsx
import { useStore } from '../../helpers/use-store';
import { Button, Col, Row, Empty } from 'antd';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { Series as SeriesType } from '@monorepo/types';
import { EyeOutlined, PlusOutlined } from '@ant-design/icons';
import { SeriesCard } from './series-card';
import ProductShowcase from '../showcase/product-showcase';
import { Helmet } from 'react-helmet';

const Series = () => {
  const navigate = useNavigate();
  const {
    dataStore: { seriesStore },
  } = useStore();

  if (seriesStore.items.length === 0) {
    return <ProductShowcase />;
  }

  const handleViewSeries = (item: SeriesType) => {
    navigate(`/series/${item._id}`);
  };

  return (
    <div>
      <Helmet>
        <title>My Series | ShortsNinja</title>
        <meta
          name="description"
          content="Organize your faceless videos into series. Manage multiple AI-generated video collections efficiently."
        />
        <meta
          name="keywords"
          content="video series, ShortsNinja, faceless videos, ai video automation, ai voiceover, video collections"
        />
      </Helmet>

      <Row gutter={[24, 24]}>
        {seriesStore.items.map((item) => (
          <Col xs={24} sm={24} md={12} xl={12} xxl={8} key={item._id}>
            <SeriesCard series={item} onView={() => handleViewSeries(item)} />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default observer(Series);
